import { render, staticRenderFns } from "./PointsSummaryPreview.vue?vue&type=template&id=8b89759e&scoped=true&"
import script from "./PointsSummaryPreview.vue?vue&type=script&lang=js&"
export * from "./PointsSummaryPreview.vue?vue&type=script&lang=js&"
import style0 from "./PointsSummaryPreview.vue?vue&type=style&index=0&id=8b89759e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b89759e",
  null
  
)

export default component.exports